// @flow

import React, { Fragment, PureComponent } from 'react';
import Spinner from '@active/awe-ui-core/lib/components/Spinner';
import Row from 'react-aaui/lib/grid/Row';
import Col from 'react-aaui/lib/grid/Col';
import L10nMessage from 'react-aaui/lib/shared/L10nMessage';
import ViewAllLink from 'components/ViewAllLink/ViewAllLink';
import Event from 'components/Event/Event';

import {
  EVENT_LIMIT,
} from 'services/query/query';
import type { Event as EVENT } from 'type/type';
import Pagination from '../Pagination/Pagination';
import './EventList.scss';

type Props = {
  keywords?: ?string,
  events?: ?Array<EVENT>,
  locale: string,
  pagination?: boolean,
  total?: number,
  currentPage?: number,
  spin?: boolean,
  onClickPage?: (?string, number) => void,
  onClickViewAll?: (keywords: ?string, offset: number, pageSize: number) => void,
}

export default class EventList extends PureComponent<Props> {
  onClickViewAll = () => {
    const { keywords, onClickViewAll, events } = this.props;
    if (onClickViewAll) {
      onClickViewAll(keywords, (events && events.length) || 0, EVENT_LIMIT);
    }
  }

  onClickPage = (page: number) => {
    const { keywords, onClickPage } = this.props;
    if (onClickPage) {
      onClickPage(keywords, page);
    }
  }

  renderTitle = (total?: number, pagination?: boolean) => {
    return (
      <div className="event-list__title">
        <L10nMessage id="page.search.tab.events" />
        <span className="event-list__title-tag">
          {total}
        </span>
        {
          !pagination ? <ViewAllLink onClickViewAll={this.onClickViewAll} /> : null
        }
      </div>
    );
  }

  render() {
    const {
      total, events, locale,
      pagination, currentPage,
      spin, renderTitleComponent,
      renderEmptyListHint,
    } = this.props;

    if (spin) {
      return <Spinner className="event-list-spinner" />;
    }

    const hint = renderEmptyListHint
      ? renderEmptyListHint() : <L10nMessage id="page.search.content.noResult" />;

    const paginationElement = pagination && total && total > EVENT_LIMIT ? (
      <div className="search-sets__container-pagination">
        <Pagination
          total={total}
          pageNumber={currentPage || 0}
          pageSize={EVENT_LIMIT}
          handleClick={this.onClickPage} />
      </div>) : null;

    return (
      <div className="event-list">
        {
          renderTitleComponent
            ? renderTitleComponent(total, pagination)
            : this.renderTitle(total, pagination)
        }
        <div className="event-list__content">
          {
            total && events && total > 0 ? (
              <Fragment>
                <Row gutter={10} fluid>
                  {
                    events.map((e) => {
                      return (
                        <Col sm={6} className="event-list__item" key={e.applicationName}>
                          <Event locale={locale} {...e} />
                        </Col>
                      );
                    })
                  }
                </Row>
                {paginationElement}
              </Fragment>) : hint
          }
        </div>
      </div>
    );
  }
}
